<script>
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import { ASYNC_SEARCH } from '@riophae/vue-treeselect'

import "@riophae/vue-treeselect/dist/vue-treeselect.css";


const simulateAsyncOperation = fn => {
  setTimeout(fn, 500)
}

export default {
  mixins: [Api, Sabit],
  props: ["Id","AdminRoleKontrol"],
  data() {
    return {
    TableData: [],
    DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },

    };
   
  },
  components: {
    Loader,
  },
  watch: {
    Id() {
      this.Get();
    },
  },
  methods: {
    Get() {
        this.ActionsFilterGet({ 
        Service: "StrBirimHarcamaLimit", 
        Page: this.Page,
        Filter: "&Birimid=" + this.Id.Birimid + "&Yil=" + this.Id.yil + "&Hesapkoduid=" + this.Id.Hesapkoduid
        }).then((res) => {
        this.TableData = res.Data
      });

        
    },

     loadOptions({ action,  callback }) {      
      if (action === ASYNC_SEARCH) {
        
          simulateAsyncOperation(() => {
             this.options = this.hesapkodlari;
          callback(null, this.options)
          
        })
       
      }
    },




    },

  

};
</script>
<template>
  <Loader>
    <b-modal
      id="StrUstLimitDetay"
      size="lg"
      title="Üst Limit Detay"
      title-class="font-18"
      hide-footer
    >
    <div class="table-responsive">
            <table class="table align-middle table-nowrap table-hover">
              <thead class="table-light">
                <tr>
                  <th scope="col">Birim</th>
                  <th scope="col">Hesap Kodu</th>
                  <th scope="col">Yıl</th>
                  <th scope="col">Üst Limit</th>
                  <th v-if="AdminRoleKontrol" scope="col" style="text-align: center;">İşlem</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(Data2, index) in this.TableData"
                  :key="index"
                >
                  <td>{{ Data2.Birimadi }}</td>
                  <td>{{ Data2.Hesapkodu }}</td>
                  <td>{{ Data2.Yil }}</td>
                  <td>{{ Data2.Ustlimit }}</td>
                  <td  v-if="AdminRoleKontrol" style="width: 85px; text-align: center;">
                    <b-button-group>
                    <b-button  @click="Delete('StrBirimHarcamaLimit', Data2.Id)" variant="danger">
                    <i class="far fa-trash-alt"></i>
                    </b-button>
                </b-button-group>




                </td>
                </tr>
              </tbody>
            </table>
    </div>



    </b-modal>
  </Loader>
</template>
